export default __webpack_public_path__ + "static/media/terminal-fluvial.30e0dd42.svg";